
define(['es6!launcher/util/constants'], Constants => function (api) {
  const services = api.properties.services;

  const loadLegacyApps = async (serviceData) => {
    const {
      imageSharerService = {},
      shareService = {},
    } = serviceData;

    // Image Sharer
    if (services.indexOf(Constants.IMAGE_SHARER_APP_UUID) !== -1) {
      const { default: ImageSharerService } = await import(
        /* webpackChunkName: "ImageSharerService" */
        'es6!services/image-sharer/index'
      );
      ImageSharerService.api = api;
      ImageSharerService.sumoProperties = api.properties;
      ImageSharerService.init(imageSharerService);
    }

    // Share
    if (
      services.indexOf(Constants.SHARE_APP_UUID) !== -1 &&
      shareService.positions &&
      shareService.positions.length !== 0
    ) {
      const { default: ShareService } = await import(
        /* webpackChunkName: "ShareService" */
        'es6!services/share/index'
      );
      ShareService.api = api;
      ShareService.initialize(shareService);
    }
  };

  const init = (opts, done) => {
    if (api.properties.mode === 'admin' || api.properties.mode === 'manage') {
      return done();
    }

    const { serviceData } = api.properties;

    if (services && serviceData) {
      loadLegacyApps(serviceData);
    }

    return done();
  };

  const destroy = done => done();

  return {
    init,
    destroy,
  };
});
